const theme = {
  colors: {
    // Light, neutral background similar to Bootstrap/iOS standard
    background: '#f8f9fa',
    surface: '#ffffff',
    primary: '#0d6efd', // bootstrap primary blue
    primaryVariant: '#084298',
    secondary: '#6c757d',
    accent: '#20c997',
    textPrimary: '#212529', // dark text for high contrast
    textSecondary: '#495057',
    border: '#dee2e6',
    muted: '#6c757d',
    success: '#198754',
    error: '#dc3545',
    placeholder: '#6c757d',
  },
  spacing: (n: number) => n * 8,
  radii: {
    sm: 6,
    md: 8,
    lg: 12,
  },
  fonts: {
    regular: 'System',
    heading: 'System',
  },
};

export type Theme = typeof theme;

export default theme;
